module.exports = __webpack_public_path__ + "static/media/flatbed-incorrect.4ae1f744.jpg";